import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Box, Stack, Typography} from '@mui/material';
import {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import {useSelector} from 'react-redux';
import {constance} from "../../common/constance/constance";
import {RootState} from "../../reducer";
import {common} from "../../common/common";
const sha256 = require('sha256');

export default function SuggestBoardDialog() {
    console.log('[SuggestBoardDialog]');

    const [open, setOpen] = useState(false);

    useEffect(() => {
        let cookieName = 'suggest-board-dialog';
        let cookie: any = common.getCookie(cookieName);
        let value = common.getTimeFormatYMD(new Date());
        if (common.isEmpty(cookie)) {
            // 00:00 까지만 쿠키 저장
            let nextDate = common.getTimeFormatYMD(new Date(value).setDate(new Date().getDate() + 1));
            let minute = Math.round((new Date(nextDate).getTime() - new Date().getTime()) / 1000 / 60) + 1;
            common.setCookie(cookieName, value, minute);
            setOpen(true);
        } else {
            if (value != cookie) {
                setOpen(true);
            }
        }
    }, []);

    const handleClose = () => {
        setOpen(false)
    };

    return (
        <div>
            <Dialog open={open} onClose={handleClose} sx={{maxHeight: '100vh'}}>
                <DialogTitle>

                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Stack>
                            <Typography variant={'h6'} sx={{mb: 0}}>
                                {`본 게시판은 절대 익명을 보장하는 비밀게시판입니다.`}
                            </Typography>
                            <Typography variant={'h6'} sx={{mb: 3}}>
                                {`작성자, IP, 사원번호 등 일체의 개인정보를 저장하지 않습니다.`}
                            </Typography>
                            <Typography variant={'h6'} sx={{mb: 3}}>
                                {`게시글은 글 작성자 본인과 사장님만 열람 가능하며 어떠한 경우에도 작성자가 누구인지 알 수 없습니다.`}
                            </Typography>
                            <Typography variant={'h6'}>
                                {`(사장님이 열람하실 때도 작성자는 익명으로 보입니다.)`}
                            </Typography>
                        </Stack>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>닫기</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}